export default {
    methods: {
        /**
         * Get the component by the dynamic refId.
         * Inside there is the real chart, which is an object
         * There are two ways to reset the zoom.
         * First way
         * https://api.highcharts.com/class-reference/Highcharts.Chart#zoomOut
         * Second way
         * this.$refs[this.refId].chart.xAxis[0].setExtremes(null, null);
         * https://api.highcharts.com/class-reference/Highcharts.Axis#setExtremes
         *
         */
        resetZoom() {
            this.$refs[this.refId].chart.zoomOut();
        }
    },
    watch: {
        /**
         * Watch the zoom key and call the reset zoom function.
         * Note: this has to be a regular function
         * @param newValue
         * @param oldValue
         */
        zoomKey(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.resetZoom();
            }
        }
    }
};